import { Link, useLocation } from "react-router-dom";
import { Anchor, Menu, X } from "lucide-react";
import { useState } from "react";

const LINKS = [
  { to: "/features", label: "Features" },
  { to: "/for-owners", label: "For Owners" },
  { to: "/for-captains", label: "For Captains" },
  { to: "/for-crew", label: "For Crew" },
  { to: "/for-providers", label: "For Providers" },
];

// Private-beta CTA — sends visitors to the moderated /request-access page.
const REQUEST_ACCESS_PATH = "/request-access";

export default function MarketingNav() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  return (
    <header
      className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-black/5"
      data-testid="marketing-nav"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="logo-home">
          <div className="w-7 h-7 rounded-md bg-ink text-white grid place-items-center">
            <Anchor className="h-4 w-4" />
          </div>
          <span className="font-display text-[17px] font-medium tracking-tight">Seavanto</span>
        </Link>

        <nav className="hidden md:flex items-center gap-7 text-sm">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={`transition-colors ${
                loc.pathname === l.to ? "text-ink" : "text-zinc-600 hover:text-ink"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2">
          <Link
            to="/login"
            data-testid="nav-login"
            className="text-sm px-3 py-1.5 text-zinc-700 hover:text-ink"
          >
            Sign in
          </Link>
          <Link
            to={REQUEST_ACCESS_PATH}
            data-testid="nav-cta"
            className="text-sm px-4 py-2 rounded-md bg-ink text-white hover:bg-black transition-colors"
          >
            Request access
          </Link>
        </div>

        <button
          className="md:hidden"
          onClick={() => setOpen(!open)}
          data-testid="mobile-nav-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-black/5 bg-white">
          <div className="px-6 py-4 flex flex-col gap-3">
            {LINKS.map((l) => (
              <Link key={l.to} to={l.to} className="py-1 text-sm" onClick={() => setOpen(false)}>
                {l.label}
              </Link>
            ))}
            <div className="border-t border-zinc-200 my-2" />
            <Link to="/login" className="py-1 text-sm" onClick={() => setOpen(false)}>Sign in</Link>
            <Link
              to={REQUEST_ACCESS_PATH}
              onClick={() => setOpen(false)}
              data-testid="mobile-nav-cta"
              className="text-sm px-4 py-2 rounded-md bg-ink text-white text-center"
            >
              Request access
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
